import { Stack, Typography, useTheme, CircularProgress } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { KCenteredContentBox } from 'components/core/KCenteredContentBox'

export const SubmitOrderProgressView = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  return (
    <KCenteredContentBox
      sx={{
        width: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        backgroundColor: theme.palette.primary.dark,
        zIndex: 10000,
        opacity: 0.85,
      }}
    >
      <Stack
        sx={{
          textAlign: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress color="info" sx={{ marginBottom: 10 }} size={80} />
        <Typography variant="h3" color={theme.palette.info.main}>
          {t('Your order is being processed.')}
        </Typography>
        <Typography variant="h3" color={theme.palette.info.main}>
          {t('Please do not close or reload this browser tab.')}
        </Typography>
      </Stack>
    </KCenteredContentBox>
  )
}
